__turbopack_context__.v({
  "blocksBackgroundColor": "SchoolFeedList-module-scss-module__NwoGEW__blocksBackgroundColor",
  "blocksFontColor": "SchoolFeedList-module-scss-module__NwoGEW__blocksFontColor",
  "container": "SchoolFeedList-module-scss-module__NwoGEW__container",
  "containerFloatingBlocks": "SchoolFeedList-module-scss-module__NwoGEW__containerFloatingBlocks",
  "secondaryNavBackgroundColor": "SchoolFeedList-module-scss-module__NwoGEW__secondaryNavBackgroundColor",
  "themeBackgroundColor": "SchoolFeedList-module-scss-module__NwoGEW__themeBackgroundColor",
  "themeFontColor": "SchoolFeedList-module-scss-module__NwoGEW__themeFontColor",
  "themeFontFamily": "SchoolFeedList-module-scss-module__NwoGEW__themeFontFamily",
});
